<app-loader [isLoading]="isLoading"></app-loader>
<div class="the_container">
  @if(!isMobileDevice){
  <span class="details-text">Review Data</span>}
  <div class="dashboard-header">

    <div class="row">
      <div class="col-md-12">
        <div class="bredcrumb">
          <ng-container *ngFor="let breadcrumb of breadcrumbs; let i = index; let last = last">
            <span (click)="onBreadcrumbClick(i)" [ngClass]="
                    !last ? 'brancd-prime me-2 cursor-pointer' : 'text-disable me-2'
                  ">{{ breadcrumb }}</span>
            <img *ngIf="!last" src="../../assets/images/chevron.svg" class="me-2" />
          </ng-container>
        </div>
      </div>
    </div>
    <!-- <app-dp-tab-menu></app-dp-tab-menu> -->
    <app-dp-tab-menu-v3></app-dp-tab-menu-v3>
    <router-outlet></router-outlet>
  </div>
</div>